import { useNavigationHelper } from 'FrontRoyalAngular';
import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { AudioVisualizerPresentation } from 'TutorBotVoiceAgent/components/AudioVisualizer';
import { SidebarBoxKey } from 'AdmissionsGuidance';
import { BasicMobileBox } from '../../BasicMobileBox';
import { ImportantCtaBox } from '../../ImportantCtaBox';

export function CoachingBox({ mobile }: { mobile?: boolean }) {
    const { loadRoute } = useNavigationHelper();

    const onPressCta = useCallback(() => {
        loadRoute('/coach');
    }, [loadRoute]);

    const visualizer = useMemo(
        () => (
            <AudioVisualizerPresentation
                color="purple"
                size="xs"
                getAgentAudioData={() => ({ agentAmplitude: 0, agentFrequencyData: null })}
                getUserAudioData={() => ({ userAmplitude: 0, userFrequencyData: null })}
            />
        ),
        [],
    );

    return mobile ? (
        <CoachingBoxMobilePresentation onPress={onPressCta} />
    ) : (
        <CoachingBoxPresentation onPressCta={onPressCta} visualizer={visualizer} />
    );
}

type PresentationProps = {
    onPressCta: () => void;
    visualizer: React.ReactNode;
};

function CoachingBoxMobilePresentation({ onPress }: { onPress: () => void }) {
    const { t } = useTranslation('back_royal', { keyPrefix: 'coachingBox' });
    return (
        <BasicMobileBox
            heading={t('mobileTitle')}
            ctaText={t('ctaText')!}
            boxKey={SidebarBoxKey.coaching}
            onPress={onPress}
            buttonId="cta"
        />
    );
}

export function CoachingBoxPresentation({ onPressCta, visualizer }: PresentationProps) {
    const { t } = useTranslation('back_royal', { keyPrefix: 'coachingBox' });

    return (
        <ImportantCtaBox
            testId="coaching-box"
            icon={visualizer}
            color="purple"
            headerSubtitle={t('subtitle')}
            headerTitle={t('title')}
            ctaText={t('ctaText') ?? ''}
            onPressCta={onPressCta}
            boxKey={SidebarBoxKey.coaching}
        >
            {t('description')}
        </ImportantCtaBox>
    );
}
